// extracted by mini-css-extract-plugin
module.exports = {"Uploader":"Uploader_Uploader__3qkwV","box":"Uploader_box__1YQDB","dragInfo":"Uploader_dragInfo__2yaik index_caption__1AJ2W"};